<template>
    <div style="background: black;">
        <div id="hero">
            <div class="hero-container">
                <div id="heroCarousel" class="carousel slide carousel-fade" data-ride="carousel">
                    <div class="carousel-indicators">
                        <img src="../assets/images/next.png" style="width: 15px;">
                    </div>
                    <div class="carousel-inner" role="listbox">
                        <div class="carousel-item active" :style="{ 'background': 'url(' + backImage + ')' }">
                            <div class="carousel-container" style="width: 100%;background: #00141b3d;">
                                <div class="carousel-content">
                                    <div style="font-size: 24px;line-height: 48px;color: #fff;font-weight: 600;">{{
                                        orgRestaurantName }}</div>
                                    <div class="text-center" ref="mydiv">
                                        <img id="logoImg" :src="logoImage" style="max-width:80%;width: 100px;">
                                    </div>
                                    <div>
                                        <div style="font-size: 16px;font-weight: 600;line-height: 20px;color: #fff;">
                                            åbningstid</div>
                                        <div style="font-size: 14px;color: #fff;">{{ totayBank.beginTime }} -
                                            {{ totayBank.endTime }}</div>
                                    </div>
                                    <div class="container" style="max-width: 540px;padding-top: 30px;">
                                        <div class="row" v-if="centerLinkList.length > 0">
                                            <div class="col-md-6 col-6" style="width: 400px;"
                                                v-for="(item, index) in centerLinkList" :key="item.id"
                                                @click.stop="menuClick(item)" :class="index % 2 === 1 ? 'right' : 'left'">

                                                <div class="action-content"
                                                    :style="{ '--bg-image': `url(${getImageRealUrl(item.iconImg)})` }"
                                                    v-if="item.buttonType == 2">
                                                    <div class="action-name">{{ item.name }}</div>
                                                    <span></span>
                                                </div>

                                                <el-button v-else class="btn-link"
                                                    :class="index % 2 === 1 ? 'whitebg' : 'redbg'">{{ item.name }}&nbsp;<img
                                                        style="width: 20px;"
                                                        :src="getImageRealUrl(item.iconImg)" /></el-button>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="nav-left">
            <div id="menu-trigger" class="nav_trigger" @click="topMenuClick">
                <div class="nav-line-1" :class="[topMenuShow ? 'nav-line-1-close' : 'nav-line-1-open']">
                </div>
                <div class="nav-line-2" :class="[topMenuShow ? 'nav-line-2-close' : 'nav-line-2-open']">
                </div>
            </div>
        </div>
        <transition name="slide-fade">
            <div class="nav-overlay" :style="topMenuShowStyle">
                <div class="nav-inner-content"
                    style="transform: translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;">
                    <div class="container-menu nav-con">
                        <div class="div-block-77" style="padding-top: 20px;">
                            <div class="main-nav-block" style="opacity: 1;" v-for="item in topMainLinkList"
                                :key="item.id">
                                <div @click.stop="menuClick(item)" class="nav-link w-inline-block">
                                    <div>{{ item.name }}</div>
                                </div>
                            </div>
                            <div class="sub-nav-block" style="opacity: 1;" v-for="item in topSubLinkList"
                                :key="item.id">
                                <div @click.stop="menuClick(item)" class="nav-link-small w-inline-block">
                                    <div>{{ item.name }}</div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </transition>

        <section id="omos" class="omos" style="background:black">
            <div class="section-title" style="padding-bottom:0;">
                <h2><span>{{ $t('restaurant') }}</span> {{ orgRestaurantName }}</h2>
            </div>
            <div style="color:white;padding:20px">
                <div class="box" v-html="restaurantInfo.description">
                </div>
            </div>
        </section>
        <section id="nyhed" class="contact">
            <div class="row findos">
                <div id="FindOs" ref="FindOs" class="contact" style="min-height: 450px;width: 100%;">
                    <div class="container">
                        <div class="section-title">
                            <h2><span>{{ $t('find') }}</span> {{ $t('os') }}</h2>
                        </div>
                    </div>
                    <div style="color: #fff;padding-bottom: 10px;">
                        <img src="../assets/images/address_white.png" style="width: 24px;padding-right: 2px;">
                        <span id="spanAddress">{{ restaurantInfo.address }} , {{ restaurantInfo.zipCode }} {{
                            restaurantInfo.zipName }}</span>
                        <img src="../assets/images/copy_white.png" title="Copy address" @click="copyAddress()"
                            style="width: 24px;padding-left: 5px;cursor: pointer;">
                    </div>
                    <el-card :body-style="{ padding: '0px' }">
                        <div id="mapBox" class="map"></div>
                        <div class="dingyue">
                            <el-form ref="form" :model="customerInfo">
                                <div style="line-height: 40px;">
                                    <el-radio v-model="customerInfo.oprType" label="1" @change="redioChange()">
                                        <span style="font-weight: 600;color: #000;">{{ $t('subscribe')
                                        }}</span></el-radio>
                                    <el-radio v-model="customerInfo.oprType" label="2" @change="redioChange()">
                                        <span style="font-weight: 600;color: #000;">
                                            {{ $t('unsubscribe') }}
                                        </span>
                                    </el-radio>
                                </div>
                                <div style="line-height: 50px;" v-if="customerInfo.oprType == 1">
                                    <el-input v-model="customerInfo.customerName" ref="customerName"
                                        placeholder="Navn"></el-input>
                                </div>
                                <div style="line-height: 50px;">
                                    <el-input v-model="customerInfo.customerPhone" ref="customerPhone"
                                        placeholder="Mobil"></el-input>
                                </div>
                                <div style="line-height: 50px;">
                                    <el-input v-model="customerInfo.customerEmail" ref="customerEmail"
                                        placeholder="E-mail"></el-input>
                                </div>
                                <div style="margin-top: 5px;">
                                    <el-button @click="updatecCustomer()" size="small"
                                        style="width: 240px;float: right;background-color: #aa2e2e;color: #fff;">
                                        {{ btnTxt }}
                                    </el-button>
                                </div>
                            </el-form>
                        </div>
                    </el-card>
                </div>
            </div>

        </section>

        <section id="Selskabs" ref="Selskabs" class="contact" style="padding-top: 30px;background: #222;">
            <div class="container">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="business-contact text-center">
                            <p><a target="_blank">
                                    <!-- <img @click="goFacebookUrl"
                                        style="background: white; border-radius: 100%;"
                                        src="../assets/images/facebook.png"> -->
                                    <img @click="goFacebookUrl" style="border-radius: 100%;width: 80px;padding: 5px;"
                                        :src="logoImage">
                                </a></p>
                            <p> <a>{{ orgRestaurantName }}</a> </p>

                            <p style="padding-top: 15px;font-size: 12px;margin-bottom:0px;"><a>{{ restaurantInfo.address
                            }}</a> </p>

                            <p style="font-size: 12px;margin-bottom:0px;"> <a>{{ restaurantInfo.zipCode }} {{
                                restaurantInfo.zipName
                            }}</a> </p>

                            <p style="font-size: 12px;margin-bottom:0px;"><a :href="getTephone"> Tlf : {{
                                telephone }}</a></p>

                            <p style="font-size: 12px;margin-bottom:10px;"><a :href="getMail">{{ email
                            }}</a></p>

                            <p><a> <img @click="goHealthUrlUrl" src="../assets/images/skrico.png" alt="" style="cursor: pointer;"> </a>
                            </p>
                            <img @click="goFacebookUrl"
                                style="background: white; border-radius: 100%;width: 30px;margin-top: 30px;margin-bottom: 10px;cursor: pointer;"
                                src="../assets/images/facebook.png">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="business-hours">
                            <h2 class="title">{{ $t('restaurant') }} <span style="color: #aa2e2e;">{{ $t('openingHours')
                            }}</span></h2>
                            <ul class="list-unstyled opening-hours">
                                <!-- <li class="today">{{ totayBank.weeks }}<span class="pull-right">{{ totayBank.beginTime
                                        }} -
                                        {{ totayBank.endTime }}</span></li> -->
                                <li v-for="item in bankList" :class="item.weeks == getToday() ? 'today-line' : ''"
                                    :key="item.id">{{ item.weeks }}
                                    <span class="pull-right">{{ item.beginTime }} - {{ item.endTime }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <footer id="footer" style="background:#35322d">
            <div class="container">
                <div class="copyright">
                    © Copyright <strong><span>{{ orgRestaurantName }}</span></strong>. All Rights Reserved
                    Power
                    by<strong>
                        <a>
                            Any2Order
                        </a>
                    </strong>
                    <div class="container">

                    </div>
                    <div class="container">
                        CVR-nr. {{ restaurantInfo.nifNo }}
                    </div>
                    <div style="vertical-align: middle; line-height: 40px;" class="clearfix">
                        <img style="margin-right: 10px; width: 43px;" src="../assets/images/visa.svg" alt="visa-icon">
                        <img style="width:37px;margin-right:10px;" src="../assets/images/mastercard.svg"
                            alt="mastercard-icon">
                    </div>

                </div>
            </div>

        </footer>

        <el-dialog title="Vælg restaurant" :width="wd" :visible.sync="dialogVisible" :show-close="true"
            :close-on-click-modal="false" :close-on-press-escape="false">
            <el-row :gutter="20">
                <el-col :span="sp" style="padding-bottom: 10px;" v-for="(item, index) in restaurants" :key="index">
                    <el-card :body-style="{ padding: '0px' }">
                        <div class="image-container" @click="selectRestaurant(item)">
                            <img :src="getImageRealUrl(item.storeImage, 600)" style="width: 100%;max-height: 200px;">
                            <div class="store-info" @click="selectRestaurant(item)">
                                <div class="store-name">{{ item.restaurantName }}</div>
                                <div class="store-address">{{ item.address }}, {{ item.zipCode }} {{ item.zipName }}
                                </div>
                                <div class="store-status">
                                    <span
                                        :class="{ 'dot': true, 'green-dot': item.isOpen, 'red-dot': !item.isOpen }"></span>
                                    <span>{{ item.isOpen ? 'Åbne' : 'Lukket' }}</span>
                                    <span class="separator"></span>
                                    <span v-if="!item.isOpen">Åbner kl. {{ item.beginTime }} i dag.</span>
                                    <span v-if="item.isOpen">Afslutning ved {{ item.endTime }} i dag.</span>
                                </div>
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </el-dialog>

    </div>
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader"; //引入
import { getConfigs, getRestaurantByName, getRestaurantBankById, getRestaurantLinkById, getRestaurantByTakeawayUrl, updatecCustomerSend } from '@/api/restaurantApi'
import $ from 'jquery'
import '@/assets/css/roboto.css'
import { setTheme } from '@/utils/theme';
const loader = new Loader({
    apiKey: "AIzaSyCvH8jYv9ajpgRXeMB9ZdVQt8y_dtkn6Vo",
    version: "3.53"
});
export default {
    name: 'Index',
    components: {

    },
    data() {
        return {
            restaurantInfo: {},
            backImage: '',
            logoImage: '',
            bankList: [],
            linkList: [],
            totayBank: {},
            weekDays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            customerInfo: {
                oprType: "1",
                customerEmail: "",
                customerPhone: "",
                customerName: "",
                restaurantId: 0
            },
            dialogVisible: false,
            prompt: '',
            promptTime: 20000,
            topMenuShow: false,
            btnTxt: '',
            tempId: 'a',
            restaurants: [],
            wd: "50%",
            sp: 12,
            rules: {
                customerName: [
                    { required: true, message: '', trigger: 'blur' },
                ],
            },
            orgRestaurantName: "",
            email:'',
            telephone:'',
        }
    },
    mounted() {
        let that = this;
        localStorage.removeItem("cartList");
        localStorage.removeItem("orderMain");
        if (this.isMobile()) {
            that.wd = "100%";
            that.sp = 24;
        }
        else {
            that.wd = "50%";
            that.sp = 12;
        }
        var restaurantName = that.$route.params.id;
        let currUrl = window.location.href.slice(0, -1);
        currUrl = this.extractDomain(currUrl);
        if(that.isMobile() && currUrl.indexOf('luckysushi')>-1){
            that.$router.replace('/mobile/index');
        }
        else if(!that.isMobile() && currUrl.indexOf('luckysushi')>-1){
            that.$router.replace('/page/index');
        }
        if (restaurantName != null && restaurantName != '' && (currUrl.indexOf('any2order')>-1 || currUrl.indexOf('127.0.0.1')>-1|| currUrl.indexOf('10.0.3.193')>-1)) {
            that.getRestaurantByName(restaurantName);
        }
        else {
            that.getRestaurantInfo();
       }
        that.redioChange();
    },
    beforeCreate() {
        document.querySelector('body').setAttribute('style', 'margin:0;')
    },
    computed: {
        topMenuShowStyle() {
            return {
                display: this.topMenuShow ? 'flex' : 'none'
            };
        },
        centerLinkList() {
            return this.linkList.filter(item => {
                return item.menuType == 1;
            });
        },
        topMainLinkList() {
            return this.linkList.filter(item => {
                return item.menuType == 2;
            });
        },
        topSubLinkList() {
            return this.linkList.filter(item => {
                return item.menuType == 3;
            });
        },
    },
    methods: {
        isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
                return flag
            },
        redioChange() {
            if (this.customerInfo.oprType == "2") {
                this.btnTxt = this.$t('unsubscribe');
            }
            else {
                this.btnTxt = this.$t('subscribe');
            }
        },
        getRestaurantByName(restaurantName) {
            let that = this;
            getRestaurantByName({ restaurantName: restaurantName }).then(data => {
                if (data != null) {
                    that.restaurantInfo = data;
                    that.orgRestaurantName = data.restaurantName;
                    that.restaurantInfo.restaurantName = data.restaurantName.trim().replace(/ /g, '')
                    that.initData();
                    that.getConfigSets();
                }
                else {
                    localStorage.setItem("i18n", "en");
                    that.$i18n.locale = "en";
                    this.$message({
                        message: this.$t("nullStore"),
                        duration: 10000,
                        offset: 200,
                        type: 'warning'
                    });
                }
            });
        },
        extractDomain(url) {
            try {
                const urlObj = new URL(url)
                const originalHost = urlObj.hostname.toLowerCase()
                const cleanHost = originalHost.replace(/^www\./i, '')
                return cleanHost;
            } catch (err) {
                return err
            }
        },
        getRestaurantInfo() {
            let that = this;
            let currUrl = window.location.href.slice(0, -1);
            currUrl = this.extractDomain(currUrl);
            getRestaurantByTakeawayUrl({ takeawayUrl: currUrl }).then(data => {
                if (data.length == 0) {
                    this.$message({
                        message: that.$t("nullStore"),
                        type: 'warning'
                    });
                }
                else if (data.length > 1) {
                    that.dialogVisible = true;
                    that.restaurants = data;
                }
                else {
                    let da = data[0];
                    if (da.restaurantName != undefined && da.restaurantName != null) {
                        that.orgRestaurantName = da.restaurantName;
                        data.restaurantName = da.restaurantName.trim().replace(/ /g, '');
                    }
                    that.restaurantInfo = da;
                    that.initData();
                    that.getConfigSets();
                }
            })
        },
        selectRestaurant(data) {
            let that = this;
            that.orgRestaurantName = data.restaurantName;
            data.restaurantName = data.restaurantName.trim().replace(/ /g, '');
            that.restaurantInfo = data;
            that.initData();
            that.getConfigSets();
            that.dialogVisible = false;
        },
        getConfigSets() {
            let that = this;
            getConfigs({ restaurantId: that.restaurantInfo.restaurantId }).then(data => {
                if (data != null) {
                    $.each(data, function (i, item) {
                        if (item.configKey == 'Prompt') {
                            that.prompt = item.configValue;
                        }
                        if (item.configKey == 'PromptTime') {
                            that.promptTime = parseInt(item.configValue) * 1000;
                        }
                        if (item.configKey == 'PageTemplate') {
                            that.tempId = item.configValue;
                        }
                        if (item.configKey == 'Theme') {
                            localStorage.setItem("theme", item.configValue);
                            setTheme(item.configValue);
                        }
                    });
                    if (that.prompt != null && that.prompt != '') {
                        this.$notify({
                            title: 'Message',
                            showClose: true,
                            position: 'bottom-left',
                            dangerouslyUseHTMLString: true,
                            duration: that.promptTime,
                            message: that.prompt
                        });
                    }
                }
            });
        },
        initData() {
            let that = this;
            localStorage.setItem("i18n", that.restaurantInfo.language.toLowerCase());
            that.$i18n.locale = that.restaurantInfo.language.toLowerCase();
            if (this.isMobile()) {
                that.backImage = that.getImageRealUrl(that.restaurantInfo.backPhoneImage);
            }
            else {
                that.backImage = that.getImageRealUrl(that.restaurantInfo.backImage);
            }
            that.logoImage = that.getImageRealUrl(that.restaurantInfo.takeawayLogo);
            that.initMap(that.restaurantInfo.map, that.restaurantInfo.restaurantName);
            that.getRestaurantBankById(that.restaurantInfo.restaurantId);
            that.getRestaurantLinkById(that.restaurantInfo.restaurantId);
            that.setTitleIcon();
        },
        copyAddress() {
            navigator.clipboard
                .writeText(this.restaurantInfo.address + "," + this.restaurantInfo.zipCode + " " + this.restaurantInfo.zipName)
                .then(() => {
                    this.$message.success("Copy address successfully.");
                })
                .catch((err) => {
                    console.error("Copy address failed!");
                });
        },
        initMap(mapsData, restaurantName) {
            let center = { lat: 55.6760968, lng: 12.5683371 };
            if (mapsData != undefined && mapsData != null && mapsData != '' && mapsData != 'null') {
                var arr = mapsData.split(',');
                center = { lat: parseFloat(arr[0]), lng: parseFloat(arr[1]) };
            }
            const mapOptions = {
                center: center,
                zoom: 17,
                disableDefaultUI: true,
            };

            loader
                .load()
                .then((google) => {
                    const map = new google.maps.Map(
                        document.getElementById("mapBox"),
                        mapOptions
                    );
                    new google.maps.Marker({
                        position: center,
                        map,
                    });
                })
                .catch((e) => {
                    console.log(e);
                });

        },
        getImageRealUrl(name, w = 0) {
            if (name == undefined || name == null) {
                name = 'default.png'
            }
            if (w == 0) {
                return this.global.httpUrl + "/uploads/" + name;
            }
            return this.global.httpUrl + "/api/images/" + w + "/" + name;
        },
        getToday() {
            let today = new Date();
            let weekd = today.getDay();
            let weeks = this.weekDays[weekd];
            return weeks;
        },
        getRestaurantBankById(restaurantId) {
            getRestaurantBankById({ restaurantId: restaurantId, bankType: 0 }).then(data => {
                if (data != null) {
                    this.bankList = data;
                    let today = new Date();
                    let weekd = today.getDay();
                    let weeks = this.weekDays[weekd];
                    var newList = [];
                    data.forEach(element => {
                        if (element.weeks == weeks) {
                            this.totayBank = element;
                        }
                        else {
                            newList.push(element);
                        }
                    });
                }
            })
        },
        getRestaurantLinkById(restaurantId) {
            getRestaurantLinkById({ restaurantId: restaurantId }).then(data => {
                if (data != null) {
                    this.linkList = data;
                    data.forEach(item => {
                       if(item.type==3 && item.templateId==3){
                        this.email=JSON.parse(item.content).email==undefined?this.restaurantInfo.email:JSON.parse(item.content).email;
                        this.telephone=JSON.parse(item.content).telephone==undefined?this.restaurantInfo.phone:JSON.parse(item.content).telephone;
                       }
                   });
                }
            })
        },
        updatecCustomer() {
            if (this.customerInfo.customerEmail == '' && this.customerInfo.customerPhone == '') {
                this.$message({
                    message: this.$t("phoneMailNotNull"),
                    type: 'warning'
                });
                return;
            }
            let isSendMsg = 1;
            if (this.customerInfo.oprType == 1) {
                isSendMsg = 1;
            }
            else if (this.customerInfo.oprType == 2) {
                isSendMsg = 2;
            }
            var param = {
                restaurantId: this.restaurantInfo.restaurantId,
                isSendSms: isSendMsg,
                customerEmail: this.customerInfo.customerEmail,
                customerPhone: this.customerInfo.customerPhone,
                customerName: this.customerInfo.customerName,
            }
            updatecCustomerSend(param).then(msg => {
                if (msg != null && msg != '') {
                    this.$message({
                        message: msg,
                        type: 'warning'
                    });
                }
                else {
                    this.customerInfo.customerName = "";
                    this.customerInfo.customerEmail = "";
                    this.customerInfo.customerPhone = "";
                    this.$message({
                        message: this.$t("submitSuccess"),
                        type: 'success'
                    });
                }
            })
        },
        menuClick(item) {
            let that = this;
            that.topMenuShow = false;
            let url = item.jumpLink;
            let restaurantName = that.restaurantInfo.restaurantName.trim().replace(/ /g, '')
            if (item.type == 2) {
                url = "/info/" + that.tempId + "/" + item.id + '/' + restaurantName;
                if (this.isMobile()) {
                    url = "/mobile/info/" + that.tempId + "/" + item.id + '/' + restaurantName;
                }
            }
            else if (item.type == 3) {
                if (item.templateId == 1) {
                    url = "/booking/" + that.tempId + "/" + restaurantName;
                    if (that.isMobile()) {
                        url = "/mobile/booking/" + that.tempId + "/" + restaurantName;
                    }
                }
                else if (item.templateId == 2) {
                    url = "/allyoucaneat/" + that.tempId + "/" + item.id + '/' + restaurantName;
                    if (that.isMobile()) {
                        url = "/mobile/allyoucaneat/" + that.tempId + "/" + item.id + '/' + restaurantName;
                    }
                }
                else if (item.templateId == 3) {
                    url = "/contact/" + that.tempId + "/" + item.id + '/' + restaurantName;
                    if (that.isMobile()) {
                        url = "/mobile/contact/" + that.tempId + "/" + item.id + '/' + restaurantName;
                    }
                }

            }
            else if (item.type == 4) {
                document.getElementById(item.jumpLink).scrollIntoView({ behavior: "smooth", block: 'center' });
                return;
            }
            else {
                window.location.href = item.jumpLink;
                return;
            }
            window.location.href = url;
        },
        isMobile() {
            if (typeof window !== 'undefined' && window.innerWidth <= 768) {
                return true;
            } else {
                return false;
            }
        },
        getTephone() {
            return "tel:" + this.telephone;
        },
        getMail() {
            return "mailto:" + this.email;
        },
        goFacebookUrl() {
            if (this.restaurantInfo.facebookUrl != null && this.restaurantInfo.facebookUrl != '') {
                //window.location.href = this.restaurantInfo.facebookUrl;
                window.open(this.restaurantInfo.facebookUrl,"_blank");
            }
        },
        goHealthUrlUrl() {
            if (this.restaurantInfo.healthUrl != null && this.restaurantInfo.healthUrl != '') {
               // window.location.href = this.restaurantInfo.healthUrl;
                window.open(this.restaurantInfo.healthUrl,"_blank");
            }
        },
        setTitleIcon() {
            document.title = this.restaurantInfo.restaurantName;
            document.querySelectorAll("link[rel*='icon']").forEach(item => {
                item.href = this.getImageRealUrl(this.restaurantInfo.takeawayLogo);
            })
        },
        topMenuClick() {
            this.topMenuShow = !this.topMenuShow;
        }
    }
}
</script>

<style scoped lang="scss">
*,
::after,
::before {
    box-sizing: border-box;
}

div {
    display: block;
}

body {
    font-family: 'Roboto', sans-serif;
    color: #444444;
    background: black;
    margin: 0px !important;
}

#hero {
    width: 100%;
    height: 100vh;
    background-color: rgba(39, 37, 34, 0.8);
    overflow: hidden;
    padding: 0;
}

.carousel-indicators {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 15;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    padding-left: 0;
    margin-right: 15%;
    margin-left: 15%;
    list-style: none;
}

.carousel-inner {
    position: relative;
    width: 100%;
    overflow: hidden;
    background-color: #000;
}

*,
::after,
::before {
    box-sizing: border-box;
}

#hero .carousel-content {
    text-align: center;
}

.text-center {
    text-align: center !important;
}

img {
    vertical-align: middle;
    border-style: none;
}

#hero .btn-menu,
#hero .btn-book {
    font-weight: 600;
    font-size: 12px;
    width: 200px;
    letter-spacing: 1px;
    text-transform: uppercase;
    display: inline-block;
    padding: 12px 30px;
    transition: 0.5s;
    line-height: 1;
    -webkit-animation-delay: 0.8s;
    animation-delay: 0.8s;
    color: black;
    border: 2px solid #fff;
}

a:not([href]) {
    color: inherit;
    text-decoration: none;
}

.fadeIn {
    opacity: 0;
    -webkit-animation: fadeIn ease-in 1;
    -moz-animation: fadeIn ease-in 1;
    animation: fadeIn ease-in 1;
    -webkit-animation-fill-mode: forwards;
    -moz-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    -webkit-animation-duration: 1s;
    -moz-animation-duration: 1s;
    animation-duration: 1s;
}

#hero .carousel-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
}

#hero .carousel-item {
    width: 100% !important;
    height: 100vh !important;
    background-size: cover !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
}

.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right,
.carousel-fade .carousel-item.active {
    z-index: 1;
    opacity: 1;
}

.carousel-fade .carousel-item {
    opacity: 0;
    transition-property: opacity;
    -webkit-transform: none;
    transform: none;
}

.carousel-item-next,
.carousel-item-prev,
.carousel-item.active {
    display: block;
}

.container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}

@media (max-width: 576px) {
    .nav-left {
        left: 1rem !important;
    }

    .container-menu {
        padding: 4.1em 1rem !important;
    }

    .nav-link {
        font-size: 2.5em !important;
    }

    .box {
        font-size: 12px;
    }
}

@media (max-width: 768px) {
    .nav-left {
        left: 1rem !important;
    }

    .container-menu {
        padding: 4.1em 1rem !important;
    }

    .nav-link {
        font-size: 2.5em !important;
    }

    .box {
        font-size: 12px;
    }

    .findos {
        padding: 20px;
        margin-bottom: 15px;
    }
}

@media (min-width: 576px) {
    .container {
        max-width: 540px
    }
}

@media (min-width: 768px) {
    .container {
        max-width: 720px
    }

    .box {
        padding-left: 20%;
        padding-right: 20%;
        font-size: 12px;
    }

    .findos {
        margin: 0px;
        padding-left: 20%;
        padding-right: 20%;
        margin-bottom: 30px;
    }
}

@media (min-width: 992px) {
    .container {
        max-width: 960px
    }
}

@media (min-width: 1200px) {
    .container {
        max-width: 1140px
    }
}

.left {
    text-align: right;
}

.right {
    text-align: left;
}

.animated {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
}

.fadeIn {
    -webkit-animation-name: fadeIn;
    animation-name: fadeIn;
}

.row-opr {
    width: 100%;
    float: left;
}

.col-opr {
    float: left;
    margin-right: 50px;
    overflow: hidden;
    cursor: pointer;
}


.row-container {
    background: rgb(255 255 255 / 52%);
    font-weight: 600;
    font-size: 12px;
    width: 100%;
    text-transform: uppercase;
    display: inline-block;
    padding: 12px;
    transition: 0.5s;
    line-height: 1;
    -webkit-animation-delay: 0.8s;
    animation-delay: 0.8s;
    color: black;
    border: 0px solid #fff;
    overflow: hidden;
    vertical-align: middle;
    cursor: pointer;
}

.row-container .title {
    height: 24px !important;
    line-height: 12px;
    vertical-align: middle;
    cursor: pointer;
}

.row-container img {
    width: 40px;
    margin: 6px;
    cursor: pointer;
}

.row-container:hover img {
    transform: translateY(-100px);
    filter: drop-shadow(#fff 0 100px);
}

.row-container:hover span {
    color: #fff;
}

.contact {
    background: black
}

.section-title {
    text-align: center;
    padding-bottom: 30px;
}

.section-title h2 {
    margin: 15px 0 0 0;
    font-size: 32px;
    font-weight: 700;
    color: #aa2e2e;
}

.section-title h2 span {
    color: #fff;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    font-weight: 700;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    font-family: 'Roboto', sans-serif;
}

.h4,
h4 {
    font-size: 1rem;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.2;
}

h4 {
    display: block;
    margin-block-start: 1.33em;
    margin-block-end: 1.33em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
}

.form-group {
    margin-bottom: 1rem;
}

.form-control {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

button,
input {
    overflow: visible;
}

button,
input,
optgroup,
select,
textarea {
    margin: 0;
    font-family: 'Roboto', sans-serif;
    font-size: inherit;
    line-height: inherit;
}

[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled),
button:not(:disabled) {
    cursor: pointer;
}

.btn-link {
    color: #000;
    font-weight: 600;
    width: 150px;
    font-size: 12px;
    letter-spacing: 0.5px;
}

.redbg {
    background-color: #aa2e2e;
    border-color: #aa2e2e;
    color: #fff;
}

.whitebg {
    background-color: #fff;
    border-color: #fff;
    color: #000;
}

// .btn-link:hover{
//     background-color: #aa2e2e;
//     border-color: #aa2e2e;
//     color: #fff;
// }
.btn {
    display: inline-block;
    font-weight: 400;
    color: #212529;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.pull-right {
    float: right;
}

.btn-primary {
    background-color: #753333;
    color: #ffffff !important;
    border: none;
}

.row {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    // margin-right: -15px;
    // margin-left: -15px;
}

.col,
.col-1,
.col-10,
.col-11,
.col-12,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-auto,
.col-lg,
.col-lg-1,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-auto,
.col-md,
.col-md-1,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-auto,
.col-sm,
.col-sm-1,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-auto,
.col-xl,
.col-xl-1,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-auto {
    padding-top: 2px;
    padding-bottom: 2px;
    padding-right: 2px;
    padding-left: 2px;
}


.business-contact.text-center a {
    color: white;
}

a {
    color: #007bff;
    text-decoration: none;
    background-color: transparent;
}

p {
    margin-bottom: -0.5rem;
}

.business-hours {
    background: #222;
    padding: 10px 14px;
    position: relative;
    margin-top: 30px;
}

.business-hours .title {
    font-size: 16px;
    color: white;
    text-transform: uppercase;
    // border-left: 4px solid #ffac0c;
}

.list-unstyled {
    padding-left: 0;
    list-style: none;
}

.business-hours li {
    color: white;
    line-height: 22px;
    // border-bottom: 1px solid #333;
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
}

.pull-right {
    float: right;
}

.business-hours .opening-hours li.today {
    color: #ff00008f;
    font-size: 14px;
}


#footer {
    color: #fff;
    font-size: 14px;
    text-align: center;
    padding: 30px 0;
}

#footer .copyright {
    margin: 0 0 5px 0;
    font-size: 12px;
}

b,
strong {
    font-weight: bolder;
}

img {
    vertical-align: middle;
    border-style: none;
}

@media (max-width: 768px) {
    .col-md-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 50%;
    }

    .col-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 50%;
    }

    .col,
    .col-1,
    .col-10,
    .col-11,
    .col-12,
    .col-2,
    .col-3,
    .col-4,
    .col-5,
    .col-6,
    .col-7,
    .col-8,
    .col-9,
    .col-auto,
    .col-lg,
    .col-lg-1,
    .col-lg-10,
    .col-lg-11,
    .col-lg-12,
    .col-lg-2,
    .col-lg-3,
    .col-lg-4,
    .col-lg-5,
    .col-lg-6,
    .col-lg-7,
    .col-lg-8,
    .col-lg-9,
    .col-lg-auto,
    .col-md,
    .col-md-1,
    .col-md-10,
    .col-md-11,
    .col-md-12,
    .col-md-2,
    .col-md-3,
    .col-md-4,
    .col-md-5,
    .col-md-6,
    .col-md-7,
    .col-md-8,
    .col-md-9,
    .col-md-auto,
    .col-sm,
    .col-sm-1,
    .col-sm-10,
    .col-sm-11,
    .col-sm-12,
    .col-sm-2,
    .col-sm-3,
    .col-sm-4,
    .col-sm-5,
    .col-sm-6,
    .col-sm-7,
    .col-sm-8,
    .col-sm-9,
    .col-sm-auto,
    .col-xl,
    .col-xl-1,
    .col-xl-10,
    .col-xl-11,
    .col-xl-12,
    .col-xl-2,
    .col-xl-3,
    .col-xl-4,
    .col-xl-5,
    .col-xl-6,
    .col-xl-7,
    .col-xl-8,
    .col-xl-9,
    .col-xl-auto {
        position: relative;
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }
}

@media (min-width: 576px) {
    .col-md-6 {
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 50%;
    }

    .col-6 {
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 50%;
    }

    .col-sm-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 50%;
    }

    .col,
    .col-1,
    .col-10,
    .col-11,
    .col-12,
    .col-2,
    .col-3,
    .col-4,
    .col-5,
    .col-6,
    .col-7,
    .col-8,
    .col-9,
    .col-auto,
    .col-lg,
    .col-lg-1,
    .col-lg-10,
    .col-lg-11,
    .col-lg-12,
    .col-lg-2,
    .col-lg-3,
    .col-lg-4,
    .col-lg-5,
    .col-lg-6,
    .col-lg-7,
    .col-lg-8,
    .col-lg-9,
    .col-lg-auto,
    .col-md,
    .col-md-1,
    .col-md-10,
    .col-md-11,
    .col-md-12,
    .col-md-2,
    .col-md-3,
    .col-md-4,
    .col-md-5,
    .col-md-6,
    .col-md-7,
    .col-md-8,
    .col-md-9,
    .col-md-auto,
    .col-sm,
    .col-sm-1,
    .col-sm-10,
    .col-sm-11,
    .col-sm-12,
    .col-sm-2,
    .col-sm-3,
    .col-sm-4,
    .col-sm-5,
    .col-sm-6,
    .col-sm-7,
    .col-sm-8,
    .col-sm-9,
    .col-sm-auto,
    .col-xl,
    .col-xl-1,
    .col-xl-10,
    .col-xl-11,
    .col-xl-12,
    .col-xl-2,
    .col-xl-3,
    .col-xl-4,
    .col-xl-5,
    .col-xl-6,
    .col-xl-7,
    .col-xl-8,
    .col-xl-9,
    .col-xl-auto {
        position: relative;
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }

}

.map {
    width: 100%;
    height: 220px;
    position: relative;
}

.dingyue {
    padding-bottom: 30px;
    padding-left: 30px;
    padding-right: 30px;
    margin-bottom: 30px;
}

.nav-left {
    width: 30%;
    display: block;
    position: absolute;
    top: 15px;
    left: 9.5rem;
}

.nav_trigger {
    z-index: 101065;
    // background-color: #000;
    outline-offset: 0px;
    cursor: pointer;
    border-radius: 100vh;
    outline: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 45px;
    height: 45px;
    padding: 0;
    display: flex;
    position: relative;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
}

.nav-line-1 {
    background-color: #fff;
    border-radius: 100vh;
    width: 24px;
    height: 1px;
    margin-bottom: 3px;
}

.nav-line-1-open {
    transform: translate3d(0px, 0em, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
    transform-style: preserve-3d;
}

.nav-line-1-close {
    transform: translate3d(0px, 4px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(45deg) skew(0deg, 0deg);
    transform-style: preserve-3d;
}

.nav-line-2 {
    background-color: #fff;
    border-radius: 100vh;
    width: 24px;
    height: 1px;
    margin-top: 3px;
}

.nav-line-2-open {
    transform: translate3d(0px, 0em, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
    transform-style: preserve-3d;
}

.nav-line-2-close {
    transform: translate3d(0px, -3px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(-45deg) skew(0deg, 0deg);
    transform-style: preserve-3d;
}

.nav-overlay {
    z-index: 1000;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    flex-direction: column;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    width: 100%;
    height: 100%;
    padding-left: 0;
    display: none;
    position: fixed;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
    max-height: 100%;
    overflow: hidden;
    transition: max-height 0.3s ease-out;
}

.nav-inner-content {
    z-index: 991;
    background-color: #000;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    padding-bottom: 1.8em;
    display: flex;
    position: relative;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: auto;
}

.container-menu {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    aspect-ratio: auto;
    text-align: left;
    -webkit-text-fill-color: inherit;
    object-fit: fill;
    background-clip: border-box;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: space-between;
    align-self: flex-start;
    align-items: center;
    width: 100%;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding: 4.1em 9.5rem;
    display: block;
    position: static;
}

.container-menu .nav {
    z-index: 999;
    align-items: center;
    margin-bottom: 0;
    padding-top: 2em;
    padding-bottom: 1.3em;
    display: flex;
    position: static;
    overflow: visible;
}

.div-block-77 {
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    display: flex;
}

.main-nav-block {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 0;
    display: flex;
}

.sub-nav-block {
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    display: flex;
}

.so-me-block {
    align-items: center;
    display: flex;
}

.nav-link {
    color: #ffffff;
    letter-spacing: -.01em;
    text-transform: uppercase;
    margin-bottom: .3em;
    font-size: 2.0em;
    font-weight: 400;
    line-height: 1;
    cursor: pointer;
}

.w-inline-block {
    max-width: 100%;
    display: inline-block;
}

.nav-link-small {
    color: #ffffff;
    letter-spacing: -.03em;
    margin-bottom: .6em;
    font-size: 1.6em;
    font-weight: 300;
    line-height: 1;
    transition: all .2s;
    cursor: pointer;
}

.image-nav-div {
    opacity: 1;
    background-image: url(https://cdn.prod.website-files.com/623994f…/627e0f4…_Nav_Menu_Image.webp);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 10px;
    flex: none;
    justify-content: center;
    align-items: center;
    width: 40%;
    height: 100%;
    display: flex;
    position: relative;
    overflow: hidden;
}

.slide-fade-enter-active {
    transition: all .3s ease;
}

.slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateY(-20px);
    opacity: 0;
}

img {
    display: inline;
}

.today-line {
    border-bottom: 1px solid #aa2e2e;
}
</style>
<style>
.el-input__inner {
    border: 1px solid #aa2e2e;
    line-height: 32px;
    height: 32px;
}

.el-radio__input.is-checked .el-radio__inner {
    border-color: #aa2e2e;
    background: #aa2e2e;
}

body {
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
}

.image-container {
    position: relative;
    /* 设置相对定位，作为 .store-info 绝对定位的参考 */
    cursor: pointer;
}

.store-info {
    position: absolute;
    /* 绝对定位，覆盖在图片上 */
    bottom: 0;
    /* 位于图片底部 */
    left: 0;
    right: 0;
    padding: 10px;
    background-color: rgba(0, 0, 0, 0.7);
    /* 黑色背景，透明度为 0.7 */
    color: #fff;
    /* 文字颜色为白色 */
}

.store-name {
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
}

.store-address {
    font-size: 10px;
    line-height: 16px;
}

.store-status {
    font-size: 12px;
    display: flex;
    align-items: center;
}

.dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
    display: inline-block;
}

.green-dot {
    background-color: green;
}

.red-dot {
    background-color: red;
}

.separator {
    width: 1px;
    height: 10px;
    background-color: rgb(226, 226, 226);
    border-radius: 100px;
    margin: 0 10px;
    display: inline-block;
}


@media (max-width: 767px) {
    .action-content {
        min-width: 0px;
    }
}
</style>
